import React from 'react';
import { BadgeAvatarSidebarView } from './BadgeAvatarSidebar.view';
import { AccountSidbarUser } from '../../../../types/user/eleve.def';
import { mediaDir } from '../../../../appolloConfig';

interface BadgeAvatarSidebarProps {
  user: AccountSidbarUser;
  goToDashboard: () => void;
  isRedirectToDashboard?: boolean;
  isMobile: boolean;
}

export const BadgeAvatarSidebar = React.memo(
  ({
    user,
    goToDashboard,
    isRedirectToDashboard = false,
    isMobile
  }: BadgeAvatarSidebarProps) => {
    const link = isRedirectToDashboard ? null : goToDashboard;
    const lienSource = user?.avatar?.media?.url
      ? mediaDir + user?.avatar?.media?.url
      : null;

    return (
      <BadgeAvatarSidebarView
        isMobile={isMobile}
        onClick={link}
        lienSource={lienSource}
        pseudo={user.firstname}
        role={user.role}
      />
    );
  }
);

BadgeAvatarSidebar.displayName = 'BadgeAvatarSidebar';
